import { api } from '@ohif/core';

function normalizeViewerToken(rawToken) {
  if (!rawToken) {
    return null;
  }

  let token = `${rawToken}`.trim();
  if (!token || token === 'undefined' || token === 'null') {
    return null;
  }

  // Accept backend responses like "token" or "Bearer token"
  if (token.startsWith('"') && token.endsWith('"')) {
    token = token.slice(1, -1).trim();
  }

  if (/^Bearer\s+/i.test(token)) {
    token = token.replace(/^Bearer\s+/i, '').trim();
  }

  return token || null;
}

/**
 * @param {Storage} storage
 * @param {string} key
 */
function readTokenFromStorage(storage, key) {
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
}

/**
 * @param {Storage} storage
 * @param {string} key
 * @param {string} value
 */
function writeTokenToStorage(storage, key, value) {
  try {
    storage.setItem(key, value);
    return storage.getItem(key) === value;
  } catch {
    return false;
  }
}

function resolveSessionIdFromValidationPayload(data) {
  const candidates = [
    data?.session_id,
    data?.sessionId,
    data?.x_api_key,
    data?.xApiKey,
    data?.api_key,
    data?.apiKey,
  ];

  for (const candidate of candidates) {
    if (!candidate) {
      continue;
    }

    const normalized = `${candidate}`.trim();
    if (normalized && normalized !== 'undefined' && normalized !== 'null') {
      return normalized;
    }
  }

  return null;
}

export async function getValidateTicketToken(temporal_token, setData) {
  const path = '/tokens/validate-temporal-token';

  console.log('Fetching token validation from API:', path);

  const body = {
    temporal_token,
    viewer: 'CT',
  };

  let data;
  try {
    const response = await api.post(path, body);
    data = response.data;
  } catch (error) {
    const detail = error.response?.data?.detail || 'Error validating token';
    throw new Error(detail);
  }

  if (typeof setData === 'function') {
    setData({
      patient: data?.patient,
      project: data?.project,
    });
  }

  const tokenViewer = normalizeViewerToken(data?.token_viewer);

  if (!tokenViewer) {
    throw new Error('Token validation succeeded but token_viewer is missing');
  }

  const persistedInSessionStorage = writeTokenToStorage(
    sessionStorage,
    'session_viewer',
    tokenViewer
  );
  const persistedInLocalStorage = writeTokenToStorage(localStorage, 'session_viewer', tokenViewer);

  const storedToken =
    readTokenFromStorage(sessionStorage, 'session_viewer') ||
    readTokenFromStorage(localStorage, 'session_viewer');

  if (!persistedInSessionStorage && !persistedInLocalStorage) {
    throw new Error(
      'session_viewer was not persisted in browser storage after temporal token validation'
    );
  }

  const sessionIdFromValidation = resolveSessionIdFromValidationPayload(data);

  if (sessionIdFromValidation) {
    localStorage.setItem('session_id', sessionIdFromValidation);
  }

  return data;
}
